<template>
  <div>
    <div class="box box-info">
      <div class="box-header with-border">
        <div class="col-md-12">
          <div class="col-md-5">
            <h3 class="box-title">{{$t('reportLiabilitiesReport.detailedReportForAMonth')}}</h3>
          </div>
          <div class="col-md-4">
            <div class="input-group date">
              <date-picker
                ref="periodPicker"
                v-model="datePickerValue"
                @dp-change="onHandleChangeMonth(datePickerValue)"
                :config="optionsPicker"
                :placeholder="$t('invoice.issuePeriod')"
              ></date-picker>
              <div class="input-group-addon" type="button" @click="$refs.periodPicker.dp.show()">
                <i class="fa fa-caret-down"></i>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="box-body">
        <div class="col-md-12">
          <b-table style="white-space: nowrap;" responsive :busy="isLoading" :items="columnData" :fields="column_fields" class="mt-3" bordered outlined>
            <template v-slot:table-busy>
                <div class="text-center text-danger my-2">
                  <b-spinner class="align-middle"></b-spinner>
                  <strong>{{$t('reportLiabilitiesReport.loading')}}</strong>
                </div>
              </template>
            <template #head()="scope">
                <div>{{ $t(scope.label == 'POWER' ? 'Điện' : (scope.label == 'WATER' ? 'Nước' : (scope.label == 'total' ? 'Tổng' : scope.label))) }}</div>
            </template>
            <template slot="target" slot-scope="row">
              <a :href="row.item.url" target="_blank" :id="`segment_target_${row.item.id}`">{{row.item.target}}</a>
              <tooltip :text="row.item.url" :target="`#segment_target_${row.item.id}`"/>
            </template>
          </b-table>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
import moment from "moment";
import datePicker from "vue-bootstrap-datetimepicker";
import utils from '@/lib/utils'

export default {
  name: "DetailedReportOfEachUnitForAMonth",
  props: {
    apartment_type: {
      type: Number,
      default() {
        return 0
      }
    }
  },
  data() {
    return {
      apartmentType: 1,
      datePickerValue: moment().format("YYYY/MM"),
      optionsPicker: {
        // useCurrent: false,
        minDate: new Date(2019, 0),
        maxDate: moment(),
        format: "YYYY/MM",
        locale: this.$i18n.locale == "en" ? "en" : "vi"
      },
      columnData: [
      ],
      column_fields: [
        { key: 'Mã Căn', label: '', class: 'text-right' },
      ],
      isLoading: false,
    };
  },
  watch: {
    GET_LANG: function() {
      this.optionsPicker.locale = this.$i18n.locale == "en" ? "en" : "vi";
    },
    DETAILED_REPORT_A_MONTH_DATA: function() {
      let data = this.DETAILED_REPORT_A_MONTH_DATA.data 
      this.column_fields = []
      this.column_fields = [
        { key: 'Mã Căn', label: 'Mã Căn', class: 'text-right' },
      ],
      this.columnData = []
      for (let i = 0, size = data.length; i < size; i++) {
        this.columnData.push({'Mã Căn': data[i].apartment_code})
      }
      for (let i = 0, size = data.length; i < size; i++) {
        for (var date_key in data[i].total_fee) {
          if (data[i].total_fee.hasOwnProperty(date_key)) {
            this.column_fields.push({key: date_key, label: date_key, class: 'text-right'})
          }
        }
      }
      for (let i = 0, size = data.length; i < size; i++) {
        for (var key in data[i].total_fee) {
          if (data[i].total_fee.hasOwnProperty(key)) {
            this.columnData[i][key] = utils.convertFormatNumberToMoney(data[i].total_fee[key])
          }
        }
      }
      // Handle remove total is 0
      let newColumnData = []
      for (let j = 0, size = this.columnData.length; j < size; j++) {
        if (this.columnData[j]['total'] != '0 VNĐ') {
          newColumnData.push(this.columnData[j])
        }
      }
      this.columnData = newColumnData
      this.isLoading = false
    }
  },
  computed: {
    ...mapGetters([
      "DETAILED_REPORT_A_MONTH_DATA"
    ])
  },
  methods: {
    ...mapActions([
      "ERROR_TOAST", "SUCCESS_TOAST",
      "GET_DETAILED_REPORT_A_MONTH"
    ]),
    submit: function(apartmentType) {
      this.apartmentType = apartmentType
      this.onRefreshReport()
    },
    onHandleChangeMonth: function(value) {
      this.onRefreshReport()
    },
    onRefreshReport: function() {
      this.isLoading = true
      let filter = {
        params: {
          ...utils.getAccountingPeriodFromDate(this.datePickerValue, "YYYY/MM"),
          // period: !isNaN(this.defaultSelected) ? this.defaultSelected : currentMonth,
          apartmentType: this.apartmentType
        }
      }
      this.GET_DETAILED_REPORT_A_MONTH(filter).then(
        function(res) {
          // To do
        }.bind(this)
      ).catch(
        function(error) {
          this.isLoading = false
        }.bind(this)
      )
    }
  },
  mounted() {
    this.onRefreshReport()
  },
  components: {
    "date-picker": datePicker
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
</style>




// WEBPACK FOOTER //
// src/views/Report/DetailedReportOfEachUnitForAMonth.vue